import React, { Fragment } from 'reactn';
import { Typography, Box, Divider, BoxProps } from '@material-ui/core';
import styled from 'styled-components';

import theme from 'meta/theme';
import KillImage from 'resources/images/features/kill.png';
import JModImage from 'resources/images/features/jmod.png';
import CasketImage from 'resources/images/features/casket.png';
import StatsImage from 'resources/images/features/stats.png';

const features = [
	{
		title: 'Kill Simulating',
		desc: `Simulate killing up to a million of a monster, in one commmand, and see a realistic image of all the loot.`,
		image: {
			src: KillImage,
			width: 486,
			height: 425,
			alt: 'Loot simulator command image.'
		}
	},
	{
		title: 'Clue Simulating',
		desc: `Simulate opening up to 50,000 clue scrolls at once, and see all the loot in a realistic image.`,
		image: {
			src: CasketImage,
			width: 486,
			height: 425,
			alt: 'Clue simulator command image.'
		}
	},
	{
		title: 'JMod Social Feeds',
		desc: `Keep up to date with updates and the JMods, by instantly getting any tweet or reddit post/comment instantly sent to your discord channel.`,
		image: {
			src: JModImage,
			width: 518,
			height: 539,
			alt: 'Jagex mod tweets and social media feeds.'
		}
	},
	{
		title: 'Check hiscores',
		desc: `Check the stats of any account with a simple command.`,
		image: {
			src: StatsImage,
			width: 456,
			height: 475,
			alt: 'Checking the stats of a runescape account.'
		}
	}
];

const SectionContainer = styled(Box)<BoxProps>`
	background: ${theme.palette.primary.dark};
	align-items: center;
	padding: ${theme.spacing(1)}px 0px;

	${theme.breakpoints.up('md')} {
		&:nth-of-type(odd) {
			flex-direction: row-reverse;
		}
		padding: ${theme.spacing(2)}px;
	}

	.MuiDivider-root {
		margin: 10px 0px;
	}

	img {
		border-radius: 6px;
	}

	${theme.breakpoints.down('sm')} {
		align-items: center;
		flex-direction: column;

		img {
			margin-top: ${theme.spacing(3)}px;
			height: auto;
			width: 100%;
			max-width: 494px;
		}
	}
`;

const Section = ({ title, desc, image }: { title: string; desc: string; image: any }) => (
	<SectionContainer display="inline-flex" justifyContent="space-around" flexWrap="wrap">
		<Box padding="0px 32px" flex="0 0 45%">
			<Typography color="secondary" variant="h4" component="h3">
				{title}
			</Typography>
			<Divider />
			<Typography>{desc}</Typography>
		</Box>

		<img
			alt={image.alt}
			loading="lazy"
			src={image.src}
			width={image.width}
			height={image.height}
		/>
	</SectionContainer>
);

const Introduction: React.FC = () => (
	<Fragment>
		<Typography gutterBottom>
			Old School Bot is a discord bot based around Old School RuneScape. It has fun and useful
			commands, such as showing your account stats or simulating the loot from monsters and
			clues.
		</Typography>

		<Box display="flex" flexDirection="column" justifyContent="space-between">
			{features.map((feat) => (
				<Section key={feat.title} {...feat} />
			))}
		</Box>
	</Fragment>
);

export default Introduction;
